<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429954068_toc01#toctitle1" id="title1"><span>Acknowledgments</span></a></div>
<div class="p"><span>A work of speculative fiction requires an open mind about the future. I’d like to thank: my friend Jim Boyette for his engineering insight to possible innovations.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>To Paul Allen for his support of the Science Fiction Museum and Hall of Fame. The idea for this novel hit me while visiting the museum in Seattle.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429954068_ack01.vue?3bfb7c00